/* eslint-disable */

/** unique or primary key constraints on table "argo.material_marriage_history" */
export enum ArgoMaterialMarriageHistoryConstraint {
  /** unique or primary key constraint on columns "material_marriage_history_id" */
  MaterialMarriageHistoryPkey = 'material_marriage_history_pkey'
}

/** select columns of table "argo.material_marriage_history" */
export enum ArgoMaterialMarriageHistorySelectColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialMarriageHistoryId = 'material_marriage_history_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note'
}

/** update columns of table "argo.material_marriage_history" */
export enum ArgoMaterialMarriageHistoryUpdateColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialMarriageHistoryId = 'material_marriage_history_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note'
}

